module.exports = __webpack_public_path__ + "img/f936067.png";